import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FeatureFlagService } from '../services/feature-flag.service';

/**
 * Resolves feature flags before activating authenticated routes under FullComponent.
 * Ensures feature flags (e.g. enableOperators) are populated in memory immediately
 * upon login without requiring a page refresh.
 */
export const featureFlagResolver: ResolveFn<unknown> = (): Observable<unknown> => {
  const featureFlagService = inject(FeatureFlagService);
  return featureFlagService.fetchFeatureFlags().pipe(
    catchError((error) => {
      console.error('Error resolving feature flags in featureFlagResolver:', error);
      return of(null);
    }),
  );
};
